export const mediaRegex = /(\[CKE_MEDIA:)([0-9]+)(\])/gmi;
export const galleryRegex = /(\[CKE_GALLERY:)([0-9]+)(\])/gmi;
export const youtubeRegex = /(\[CKE_YOUTUBE:)([^/><]+)(\])/gmi;
export const formRegex = /(\[CKE_FORM:)([^/><]+)(\])/gmi;
export const linkRegex = /(\[CKE_LINK:)([^/><]+)(\])/gmi;
export const audioRegex = /(\[CKE_AUDIO:)([^/><]+)(\])/gmi;
export const accordionRegex = /(\[CKE_ACC:)([^/><]+)(\])/gmi;
export const anchorRegex = /(\[CKE_ANCHOR:)([0-9]+)(-:-)(https?:\/\/(www\.)?[-a-zA-Z0-9@:%._+~#=]{1,256}\.[a-zA-Z0-9()]{1,6}\b([-a-zA-Z0-9()@:%_+.~#?&//=]*)(\]))/gmi;
export const subscriptionRegex = /(\[CKE_SUBSCRIPTION])/gmi;
export const gmapRegex = /(\[CKE_GMAP:)(.*)(\])/gmi;
export const actionRegex = /(\[CKE_ACTION:)([^-:-]*)(-:-)([^\]]*)(\])/gmi;
export const imageTextRegex = /(\[CKE_IMAGE_TEXT:)([0-9]+)(-:-)([0-9]+)(-:-)([^\]]*)(\])/gmi;
export const pageRegex = /(\[CKE_PAGE:)([0-9]+)(-:-)([^\]]*)(\])/gmi;
export const ccLogoRegex = /(\[CKE_CC_LOGO:)([^/><]+)(\])/gmi;
export const stampRegex = /(\[CKE_STAMP:)([^/><]+)(\])/gmi;
